import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
} from '../../components/typography';
import { Price } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px" itemprop="name">Svejsning med kulsyre</Heading1>
                  <hr />
                  <Div itemprop="name">
                    <Paragraph>
                      Jeg har sådan to co2 flasker til og stå. Flasken er grå og er en 6kg.
                    </Paragraph>
                    <Paragraph>
                      Ville høre om man må fylde op med det co2 som man bruger til fadølsanlæg eller om man kun må bruge den til svejsning? og hvad I evt. vil give for den ene.
                    </Paragraph>
                  </Div>
                  <hr />
                  <Paragraph>
                    <Bold>Svar:</Bold>
                  </Paragraph>
                  <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <Paragraph>
                      Du kan sagtens bruge fadøls co2 til at svejse med, det er nøjagtigt det samme.
                    </Paragraph>
                    <Paragraph>Vi fylder ikke selv, så du kan ikke få fyldt din grå flaske.</Paragraph>
                    <Paragraph>Den grå flaske har med stor sandsynlighed ikke nogen værdi, den er sikkert gammel og mangler måske den lovpligtige trykprøvning hver tiende år.</Paragraph>
                    <Paragraph>Du kan købe en ny flaske hos os, pris for indhold <Price varenr="8940" />,- med moms pris for pant 800,- med moms som du får igen når du afleverer den.</Paragraph>
                    <Paragraph><LinkStyled to="/kulsyre">Læs mere om kulsyreflasker her</LinkStyled></Paragraph>
                  </Div>
                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
